import { parseWixMediaUrl, buildTransformUrl } from '@/components/ui/image-helpers';

function normalizeToCdn(src) {
  if (typeof src !== 'string') return src;
  const match = src.match(
    /^https:\/\/base44\.app\/api\/apps\/[a-f0-9]{24}\/files\/mp\/public\/([a-f0-9]{24})\/(.+\.(?:jpe?g|png|webp))(?:\?.*)?$/i
  );
  return match
    ? `https://media.base44.com/images/public/${match[1]}/${match[2]}`
    : src;
}

/**
 * Builds a CDN transform URL + 1x/2x srcSet for a product image.
 * Skips the Image component's useLayoutEffect/useSize pipeline entirely.
 * @param {string} src - Original image URL (base44.app or media.base44.com)
 * @param {number} width - Base display width in CSS pixels (1x)
 * @param {number} heightRatio - height / width (e.g. 5/4 for aspect-[4/5])
 * @param {number} quality - JPEG/WebP quality 1-100
 */
export function buildImgUrls(src, width, heightRatio = 5 / 4, quality = 75) {
  const cdnUrl = normalizeToCdn(src);
  const parsed = parseWixMediaUrl(cdnUrl);
  if (!parsed) return { src: cdnUrl, srcSet: undefined };
  const height = Math.round(width * heightRatio);
  const opts = { width, height, crop: true, quality };
  const w2 = { ...opts, width: width * 2, height: height * 2 };
  return {
    src: buildTransformUrl(parsed, opts),
    srcSet: `${buildTransformUrl(parsed, opts)} 1x, ${buildTransformUrl(parsed, w2)} 2x`,
  };
}